import React from 'react';
import { Link } from 'react-router-dom';
import { Cloud, Shield, Brain, DollarSign, Settings, Workflow, ArrowRight } from 'lucide-react';

const SolutionsSection = () => {
  const solutions = [
  {
    icon: Cloud,
    title: 'Cloud Migration',
    description: 'Seamlessly migrate your workloads to AWS with zero downtime and optimized performance.',
    path: '/services/cloud-migration'
  },
  {
    icon: Shield,
    title: 'Cloud Security & Compliance',
    description: 'Enterprise-grade security architecture meeting the highest compliance standards.',
    path: '/services/cloud-security'
  },
  {
    icon: Brain,
    title: 'Data & AI/ML Solutions',
    description: 'Transform your data into actionable insights with advanced AI/ML capabilities.',
    path: '/services/data-ai-ml'
  },
  {
    icon: DollarSign,
    title: 'FinOps - Cost Optimization',
    description: 'Reduce cloud costs by up to 60% without compromising performance or security.',
    path: '/services/cost-optimization'
  },
  {
    icon: Settings,
    title: 'AWS Managed Services',
    description: "proactive management and optimization of your AWS infrastructure.",
    path: '/services/managed-services'
  },
  {
    icon: Workflow,
    title: 'DevOps Automation',
    description: 'Accelerate delivery with CI/CD pipelines and infrastructure as code.',
    path: '/services/devops'
  }];


  return (
    <section className="py-20 bg-gradient-to-b from-[#020B1A] to-[#061426]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Comprehensive AWS Solutions
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            End-to-end cloud services designed to accelerate your digital transformation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => {
            const Icon = solution.icon;
            return (
              <div
                key={index}
                className="bg-gradient-to-br from-[#061426] to-[#0A1E3F] border border-cyan-500/30 rounded-xl p-8 transition-all duration-300 hover:border-cyan-400 hover:shadow-2xl hover:-translate-y-1 group"
                style={{ boxShadow: '0 4px 20px rgba(0, 212, 255, 0.1)' }}>

                <div className="w-14 h-14 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border border-cyan-500/30 rounded-lg flex items-center justify-center mb-6 group-hover:border-cyan-400 transition-all duration-300" style={{ boxShadow: '0 0 15px rgba(0, 212, 255, 0.2)' }}>
                  <Icon className="w-7 h-7 text-cyan-400 group-hover:text-cyan-300 transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{solution.title}</h3>
                <p className="text-gray-400 mb-6 leading-relaxed">{solution.description}</p>
                <Link to={solution.path} className="flex items-center space-x-2 text-cyan-400 font-medium group-hover:text-cyan-300 transition-colors">
                  <span>Learn More</span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>);

          })}
        </div>
      </div>
    </section>);

};

export default SolutionsSection;